import React, { useContext, useState } from "react";
import { AiOutlineExperiment } from "react-icons/ai";
import SimulationContext from "../../../../contexts/simulation";
import { DynamicForm } from "../../../DynamicForm";
import styles from "./request.module.css";

const config = {
  body: {
    type: "code",
    label: {},
    default: "{}",
  },
};

const RequestBody = ({ launchSimulation }) => {
  const [simulationState, simulationDispatcher] = useContext(SimulationContext);

  const [data, setData] = useState({});

  const handleDataChange = function (data) {
    try {
      //setData(data.body)
      simulationDispatcher({
        type: "update-allo-brain-simulation-body",
        data: data.body,
      });
    } catch (e) {
      //pass
    }
  };

  /*useEffect(() => {
        if (simulationState.alloBrainSimulationBody) {
            console.log("hello l", simulationState.alloBrainSimulationBody)
            setData(simulationState.alloBrainSimulationBody)
        } else {
            setData("{}")
        }
    }, [])

    useEffect(() => {
        if (data) {
            simulationDispatcher({
                type: 'update-allo-brain-simulation-body',
                data
            })
        }
    }, [data])*/

  /*useEffect(() => {
        // Body request save
        if (JSON.stringify(data) !== JSON.stringify(simulationState.alloBrainSimulationBody)) {
            simulationDispatcher({
                type: 'update-allo-brain-simulation-body',
                data
            })
        }
    }, [data])*/

  const handleLaunchButtonClick = function () {
    launchSimulation(JSON.parse(simulationState.alloBrainSimulationBody));
  };

  return (
    <div className={styles.request_body_container}>
      <DynamicForm
        formData={{
          body: simulationState.alloBrainSimulationBody,
        }}
        onParameterChange={handleDataChange}
        parametersModel={config}
        utilsData={{}}
      />

      <div className={styles.send_button_container}>
        <AiOutlineExperiment
          className={styles.simulation_button}
          onClick={handleLaunchButtonClick}
        />
      </div>
    </div>
  );
};

export default RequestBody;
